import { render, staticRenderFns } from "./ReferralInfo.vue?vue&type=template&id=3c983449&scoped=true&"
import script from "./ReferralInfo.vue?vue&type=script&lang=js&"
export * from "./ReferralInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReferralInfo.vue?vue&type=style&index=0&id=3c983449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c983449",
  null
  
)

export default component.exports